jQuery( document ).ready( function( $ ) {


	// Platzhaltertext im Textarea entfernen beim Klick
	const messageTextarea = $( 'textarea[name="waldwelt_order[message]"]' );
	const placeholderText = "Ihre Nachricht an uns";

	messageTextarea.on( 'focus', function() {
		if ( $( this ).val() === placeholderText ) {
			$( this ).val( '' );
		}
	} );

	messageTextarea.on( 'blur', function() {
		if ( $( this ).val() === '' ) {
			$( this ).val( placeholderText );
		}
	} );





	$( '#waldwelt-cart' ).on( 'submit', function( event ) {
		event.preventDefault();

		// Formulardaten sammeln
		let formData = $( this ).serializeArray();
		// Warenkorb-Daten hinzufügen
		formData.push( { name: 'waldweltCart', value: JSON.stringify( window.waldweltCart ) } );

		// Debug: Formulardaten und Warenkorb in der Konsole anzeigen
		console.log( 'Formulardaten:', formData );
		console.log( 'Warenkorb:', window.waldweltCart );

		// AJAX-Anfrage senden
		$.ajax( {
			url: waldwelt_vars.ajaxurl, // WordPress AJAX URL (z.B. admin-ajax.php)
			type: 'POST'
			, data: {
				action: 'submit_waldwelt_order'
				, form_data: formData
			}
			, beforeSend: function() {
				// Debug: Vor dem Absenden
				console.log( 'AJAX-Anfrage wird vorbereitet:', formData );
			}
			, success: function( response ) {
				// Debug: Antwort in der Konsole anzeigen
				console.log( 'Erfolgreiche Antwort:', response );

				if ( response.success ) {
					// Erfolgsmeldung anzeigen
					$( '#waldwelt-cart' ).addClass( 'is-valid' ).removeClass( 'is-invalid' );

					$( '.successmessage' ).removeClass( 'd-none' );

					$( '.d-unsent' ).addClass( 'd-none' );
					$( '.d-unsent' ).removeClass( 'd-lg-block' );


				} else {
					// Fehlerbehandlung
					$( '#waldwelt-cart' ).addClass( 'is-invalid' ).removeClass( 'is-valid' );
					alert( 'Es gab einen Fehler. Bitte überprüfe deine Angaben.' );
				}
			}
			, error: function( jqXHR, textStatus, errorThrown ) {
				// Debug: Fehler anzeigen
				console.error( 'Fehler bei der AJAX-Anfrage:', textStatus, errorThrown );
				$( '#waldwelt-cart' ).addClass( 'is-invalid' ).removeClass( 'is-valid' );
				alert( 'Es gab einen Fehler bei der Verbindung. Bitte versuche es später noch einmal.' );
			}
		} );
	} );
} );